import AdminAbsences from './admin-absences'

export default AdminAbsences
